<app-map [mappaData]="data"></app-map>
<nav class="church-list-container" aria-label="Lista chiese">
  <h2>Vieni a trovarci</h2>
  <div class="search-input">
    <input
      type="text"
      placeholder="Cerca una città..."
      [(ngModel)]="searchValue"
      (input)="onSearchChange()"
      aria-label="Cerca una città"
    />
    <button (click)="usePosition()" aria-label="Usa la mia posizione">
      <img src="/icons/location.png" alt="" />
    </button>
  </div>
  <div class="church-list" role="list">
    @if (sortedChiese.length > 0) {
      @for (church of sortedChiese; track church.id) {
        <article class="church-item" role="listitem" (click)="focusOnChurch(church.id || '')">
          <img src="/icons/church.png" alt="" aria-hidden="true" />
          <div class="church-info">
            <h3>{{ church.nome }}</h3>
            <address>
              <p>{{ church.indirizzo }}</p>
              @if (church.orari) {
                <p class="orari">{{ church.orari }}</p>
              }
              @if (church.telefono) {
                <p class="telefono">
                  <a [href]="'tel:' + church.telefono">{{ church.telefono }}</a>
                </p>
              }
            </address>
            @if (church.distance !== undefined) {
              <small class="distance">{{ church.distance | number: "1.1-1" }} km</small>
            }
          </div>
        </article>
      }
    } @else {
      @for (church of data?.chiese; track church.id) {
        <article class="church-item" role="listitem" (click)="focusOnChurch(church.id || '')">
          <img src="/icons/church.png" alt="" aria-hidden="true" />
          <div class="church-info">
            <h3>{{ church.nome }}</h3>
            <address>
              <p>{{ church.indirizzo }}</p>
              @if (church.orari) {
                <p class="orari">{{ church.orari }}</p>
              }
              @if (church.telefono) {
                <p class="telefono">
                  <a [href]="'tel:' + church.telefono">{{ church.telefono }}</a>
                </p>
              }
            </address>
          </div>
        </article>
      }
    }
  </div>
</nav>
